module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "dashboard-settings"
    }
  }, [(!_vm.isLoading) ? _c('div', [_c('mu-card-header', {
    staticClass: "dashedItem",
    attrs: {
      "titleClass": "boldTitle largeTitle",
      "title": _vm.title,
      "subTitle": _vm.subTitle
    }
  }), _vm._v(" "), _c('mu-list', [_c('draggable', {
    attrs: {
      "options": {
        draggable: '.item',
        handle: '.handle'
      }
    },
    model: {
      value: (_vm.order),
      callback: function($$v) {
        _vm.order = $$v
      },
      expression: "order"
    }
  }, _vm._l((_vm.order), function(item, index) {
    return _c('mu-list-item', {
      key: 'card-order-' + index,
      staticClass: "item dashboardItem dashedItem",
      class: {
        'odd': index % 2 === 0
      },
      attrs: {
        "title": _vm.$t(_vm.getNameByKey(item.name)),
        "disableRipple": ""
      }
    }, [_c('mu-checkbox', {
      staticClass: "greenIcon",
      attrs: {
        "slot": "left",
        "uncheckIcon": "radio_button_checked",
        "checkedIcon": "radio_button_unchecked"
      },
      slot: "left",
      model: {
        value: (item.hidden),
        callback: function($$v) {
          _vm.$set(item, "hidden", $$v)
        },
        expression: "item.hidden"
      }
    }), _vm._v(" "), _c('mu-icon', {
      staticClass: "handle",
      attrs: {
        "slot": "after",
        "value": "menu"
      },
      slot: "after"
    })], 1)
  }), 1)], 1), _vm._v(" "), _c('mu-card-text', [(_vm.order.length > 0) ? _c('mu-raised-button', {
    staticClass: "large",
    attrs: {
      "disabled": _vm.isUpdating,
      "label": !_vm.isUpdating ? _vm.$t('message.updateText') : _vm.$t('message.updatingText'),
      "fullWidth": "",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitForm()
      }
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('mu-flexbox', {
    staticStyle: {
      "height": "316px"
    },
    attrs: {
      "justify": "center center",
      "align": "center center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 46
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b50e320","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Settings/Dashboard.vue
// module id = 3244
// module chunks = 1